/**
 * Bayi bazlı minimum sipariş tutarı.
 *
 * Sepette BİRDEN FAZLA satıcının ürünü varsa, her satıcının kendi ürünleri
 * toplamı ayrı ayrı en az MIN_AMOUNT_CENTS olmalı. Sebep: her bayi kendi
 * deposundan ayrı çıkıyor, bayi başına ayrı bir "mini sipariş" oluşuyor ve
 * çok düşük tutarlı gönderiler bayi için karlı olmuyor.
 *
 * Sepette TEK bayi varsa bu kural uygulanmaz.
 *
 * Ödeme düğmeleri, eksik bayi kalmadığı sürece kilitli tutulur. Müşteriye
 * eksik tutar bayi bazlı gösterilir; ya o bayiden ucuzdan pahalıya sıralı
 * ürünlere yönlendirilir ya da o bayinin ürünlerini sepetten tek tuşla
 * çıkarabilir.
 *
 * trendmiya-single-vendor-cart.js'in yerini alır (o dosya artık kullanılmıyor,
 * sepette birden fazla bayiden alışverişe artık izin veriliyor).
 */
(function () {
  if (window.__trendmiyaVendorMinimum) return;
  window.__trendmiyaVendorMinimum = true;

  // Bayi başına minimum tutar, kuruş cinsinden (Shopify cart.js tutarları
  // kuruş/cent döner). 25000 = 250,00 TL.
  var MIN_AMOUNT_CENTS = 25000;

  var WRAP_CLASS = "tm-vendor-min";
  var DISABLED_CLASS = "tm-vendor-min-disabled";
  var DISABLED_MARK_ATTR = "data-tm-min-disabled";

  var CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'a[href^="/checkout"]',
    ".cart__checkout-button",
    "#checkout",
    "#CartDrawer-Checkout"
  ].join(", ");

  // ------------------------------------------------------------- yardımcı

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function formatMoney(cents) {
    try {
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === "function") {
        return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
      }
    } catch (e) {
      /* aşağıdaki sade biçime düş */
    }
    return (cents / 100).toFixed(2).replace(".", ",") + " TL";
  }

  /** Sepeti bayi adına göre gruplar; boş bayi adı olan satırlar sayılmaz. */
  function groupByVendor(cart) {
    var order = [];
    var byVendor = {};

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var vendor = (item.vendor || "").trim();
      if (!vendor) return;

      if (!byVendor[vendor]) {
        byVendor[vendor] = { vendor: vendor, total: 0 };
        order.push(vendor);
      }

      byVendor[vendor].total += item.final_line_price;
    });

    return order.map(function (vendor) {
      return byVendor[vendor];
    });
  }

  /**
   * Bir bayinin STOKTA OLAN ürünlerini ucuzdan pahalıya sıralı listeleyen
   * arama linki. options[unavailable_products]=hide, Shopify'ın arama
   * sonuçlarından stokta olmayan ürünleri düşen resmi parametresi.
   */
  function vendorSearchUrl(vendor) {
    var q = 'vendor:"' + vendor.replace(/"/g, '\\"') + '"';
    return (
      "/search?q=" + encodeURIComponent(q) +
      "&type=product&sort_by=price-ascending&options%5Bunavailable_products%5D=hide"
    );
  }

  function uniqueButtons() {
    var found = Array.prototype.slice.call(document.querySelectorAll(CHECKOUT_SELECTORS));
    var unique = [];

    found.forEach(function (el) {
      if (unique.indexOf(el) === -1) unique.push(el);
    });

    return unique;
  }

  // ------------------------------------------------------------- devre dışı

  function disableButton(btn) {
    if (btn.hasAttribute("disabled")) return;
    btn.setAttribute("disabled", "disabled");
    btn.setAttribute(DISABLED_MARK_ATTR, "true");
    btn.classList.add(DISABLED_CLASS);
  }

  /** Yalnızca BİZİM devre dışı bıraktığımız düğmeyi geri açar. */
  function enableButton(btn) {
    if (btn.getAttribute(DISABLED_MARK_ATTR) !== "true") return;
    btn.removeAttribute("disabled");
    btn.removeAttribute(DISABLED_MARK_ATTR);
    btn.classList.remove(DISABLED_CLASS);
  }

  // ------------------------------------------------------------------ kutu

  function ensureBox(btn) {
    var prev = btn.previousElementSibling;
    if (prev && prev.classList.contains(WRAP_CLASS)) return prev;

    var box = document.createElement("div");
    box.className = WRAP_CLASS;
    btn.parentNode.insertBefore(box, btn);
    return box;
  }

  function removeBox(btn) {
    var prev = btn.previousElementSibling;
    if (prev && prev.classList.contains(WRAP_CLASS)) prev.remove();
  }

  function renderBoxContent(box, failingGroups) {
    box.innerHTML = failingGroups
      .map(function (group) {
        var missing = MIN_AMOUNT_CENTS - group.total;

        return (
          '<div class="' + WRAP_CLASS + '__row">' +
          '<p class="' + WRAP_CLASS + '__text">' +
          "<strong>" + escapeHtml(group.vendor) + "</strong> için sepette " +
          formatMoney(group.total) + " var, en az " + formatMoney(MIN_AMOUNT_CENTS) +
          " olması gerekiyor. Devam etmek için " +
          "<strong>" + formatMoney(missing) + "</strong> daha ürün ekleyin." +
          "</p>" +
          '<div class="' + WRAP_CLASS + '__actions">' +
          '<a href="' + vendorSearchUrl(group.vendor) + '" class="' + WRAP_CLASS + '__add">' +
          '<span>' + escapeHtml(group.vendor) + "&#39;dan Ürün Ekle</span>" +
          '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7.5 4.5a1 1 0 0 1 1.4-.1l5 4.5a1 1 0 0 1 0 1.5l-5 4.5a1 1 0 1 1-1.3-1.5L11.6 10 7.6 6.4a1 1 0 0 1-.1-1.4Z"/></svg>' +
          "</a>" +
          '<button type="button" class="' + WRAP_CLASS + '__remove" data-tm-min-remove-vendor="' + escapeHtml(group.vendor) + '">Bu satıcıyı sepetten çıkar</button>' +
          "</div>" +
          "</div>"
        );
      })
      .join("");
  }

  function escapeHtml(text) {
    var div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  // ------------------------------------------------------------ satıcı sil

  function removeVendorItems(vendor) {
    fetchCart().then(function (cart) {
      var updates = {};

      (cart && cart.items ? cart.items : []).forEach(function (item) {
        if ((item.vendor || "").trim() === vendor) updates[item.key] = 0;
      });

      if (Object.keys(updates).length === 0) return;

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates })
      })
        .catch(function () {})
        .then(function () {
          // Sepet çekmecesi/sayfası kendi HTML'ini bu istekten haberdar
          // olmadan yeniden çizmiyor; en güvenli yol sayfayı yenilemek.
          window.location.reload();
        });
    });
  }

  // -------------------------------------------------------------- ana akış

  function render(cart) {
    var groups = groupByVendor(cart);
    var buttons = uniqueButtons();

    // Kural yalnızca sepette birden fazla bayi varken geçerli.
    if (groups.length < 2) {
      buttons.forEach(function (btn) {
        removeBox(btn);
        enableButton(btn);
      });
      return;
    }

    var failing = groups.filter(function (g) {
      return g.total < MIN_AMOUNT_CENTS;
    });

    buttons.forEach(function (btn) {
      if (failing.length === 0) {
        removeBox(btn);
        enableButton(btn);
        return;
      }

      var box = ensureBox(btn);
      renderBoxContent(box, failing);
      disableButton(btn);
    });
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      if (cart) render(cart);
    });
  }

  // Kutu içindeki "sepetten çıkar" düğmelerini tek bir dinleyiciyle yakala.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-tm-min-remove-vendor]");
    if (!btn) return;

    e.preventDefault();
    btn.disabled = true;
    removeVendorItems(btn.getAttribute("data-tm-min-remove-vendor"));
  });

  // ------------------------------------------------------- sepet değişimi

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch;

  window.fetch = function (resource, config) {
    var url = typeof resource === "string" ? resource : (resource && resource.url) || "";
    var isMutation = CART_MUTATION_RE.test(url);

    if (!isMutation) return originalFetch.apply(this, arguments);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (response.ok) refresh();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tmMinUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;

    if (xhr.__tmMinUrl && CART_MUTATION_RE.test(String(xhr.__tmMinUrl))) {
      xhr.addEventListener("load", function () {
        if (xhr.status >= 200 && xhr.status < 300) refresh();
      });
    }

    return originalSend.apply(this, arguments);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }
})();
